/**
 * levelTree的模式工厂
 * author: YuJiaBei
 * date: 2020/8/7
 */

import {customQueryForEmFilterPatternFactory} from "@/store/em/commonPattern/customQueryForEmFilterPatternFactory";

export function levelTreePatternFactory({
                                            store,
                                            store: {state, actions, mutations}
                                            , param: {
                                                entity,
        modelFilter = {}
    }
                                        } = {}) {
    //先调用customQuery的工厂
    customQueryForEmFilterPatternFactory({
        store, param:
            {
                modelFilter,
                loadState: 'levelTreeNodes',
                filterState: 'levelTreeFilter'
            }
    })

    //再添加levelTree特有的
    //statue
    Object.assign(state, {handleClicking: false})
    //mutations
    Object.assign(mutations, {
        setHandleClicking(state, data) {
            state.handleClicking = data
        }
    })
    //actions
    Object.assign(actions, {
        retrieveLevelTreeNodes(context) {
            context.dispatch("api/post", {
                url: `${context.state.baseModuleUrl}/${entity}/findByFilter`,
                data: context.state['levelTreeFilter']
            }, {root: true}).then(response => {
                context.commit("setLevelTreeNodes", response.data.list)
            })
        },
        //overwrite,刷新LevelTreeNodes
        afterLoadRowsTrigger(context) {
            if (!context.state.handleClicking) {
                context.dispatch("retrieveLevelTreeNodes")
            } else {
                context.commit("setHandleClicking", false)
            }
        }
    })

}